export default "__VITE_ASSET__MFeezHIK__"